export const BILLING_STEPS = {
  PLAN_SELECTION: 'PLAN_SELECTION',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  BILLING_DATA: 'BILLING_DATA',
  CHECKOUT: 'CHECKOUT',
  SUCCESS: 'SUCCESS',
};

